<button style="display: none"></button>
<div class="flex header-idfx" style="height: 57vh">
  @for (filter of filters; track $index) {
    <div class="flex-1">
      <div class="mb-3 pl-3">
        <b>{{ filter.header | translate }}</b>
      </div>
      <div class="relative">
        @if (filter.type == "select") {
          <p-scrollPanel [style]="{ height: '45vh', background: 'white' }">
            <p-tree
              class="select"
              [filter]="filter.search"
              styleClass="noChildren"
              [filterBy]="filter.key"
              [style]="{ height: '100%' }"
              [value]="filter.values"
              [selectionMode]="getSelectionMode(filter)"
              [(selection)]="values[filter.name]"
              (selectionChange)="outlined = false"
            >
              @if (filter.key) {
                <ng-template let-node pTemplate="default">
                  <div>
                    @if (filter.display) {
                      <span class="p-ml-2">{{ node[filter.display] }}</span>
                    } @else {
                      <span class="p-ml-2">{{ node[filter.key] }}</span>
                    }
                  </div>
                </ng-template>
              }
            </p-tree>
          </p-scrollPanel>
        } @else if (filter.type == "date") {
          <div class="p-3">
            <div>
              <p-datepicker
                appendTo="body"
                [showIcon]="true"
                [placeholder]="'filters.enterStartDate' | translate"
                [(ngModel)]="values[filter.name][0]"
                dateFormat="dd/mm/yy"
                (ngModelChange)="dateChange('start', values[filter.name][0])"
                [readonlyInput]="true"
                [showTime]="true"
                [showButtonBar]="true"
                [maxDate]="maxDate"
              />
              <div class="h-1rem"></div>
              <p-datepicker
                appendTo="body"
                [showIcon]="true"
                [placeholder]="'filters.enterEndDate' | translate"
                [(ngModel)]="values[filter.name][1]"
                dateFormat="dd/mm/yy"
                (ngModelChange)="dateChange('end', values[filter.name][1])"
                [readonlyInput]="true"
                [showTime]="true"
                [showButtonBar]="true"
                [minDate]="minDate"
              />
            </div>
            <div>
              <div>
                <div class="block pt-3">
                  <p-radioButton
                    name="calendar"
                    value="day"
                    inputId="day"
                    [(ngModel)]="since"
                    (ngModelChange)="
                      updateDateValues(filter.name); outlined = false
                    "
                  />
                  <label for="day" class="ml-2">
                    {{ "filters.fromYesterday" | translate }}
                  </label>
                </div>
                <div class="block pt-3">
                  <p-radioButton
                    name="calendar"
                    value="week"
                    inputId="week"
                    [(ngModel)]="since"
                    (ngModelChange)="
                      updateDateValues(filter.name); outlined = false
                    "
                  />
                  <label for="week" class="ml-2">
                    {{ "filters.fromWeek" | translate }}
                  </label>
                </div>
                <div class="block pt-3">
                  <p-radioButton
                    name="calendar"
                    value="month"
                    inputId="month"
                    [(ngModel)]="since"
                    (ngModelChange)="
                      updateDateValues(filter.name); outlined = false
                    "
                  />
                  <label for="day-30" class="ml-2">
                    {{ "filters.fromMonth" | translate }}
                  </label>
                </div>
                <div class="block pt-3">
                  <p-radioButton
                    name="calendar"
                    value="year"
                    inputId="year"
                    [(ngModel)]="since"
                    (ngModelChange)="
                      updateDateValues(filter.name); outlined = false
                    "
                  />
                  <label for="year" class="ml-2">
                    {{ "filters.fromYear" | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        } @else if (filter.type == "categoryTree") {
          <p-tree
            [scrollHeight]="'45vh'"
            [value]="filter.values"
            [filter]="true"
            filterBy="categoryLabelLoc"
            selectionMode="checkbox"
            (selectionChange)="outlined = false"
            [(selection)]="values[filter.name]"
          >
            <ng-template let-node pTemplate="default">
              <div>
                <span class="p-ml-2">{{ node.categoryLabelLoc }}</span>
              </div>
            </ng-template>
          </p-tree>
        } @else if (filter.type == "statusTree") {
          <p-tree
            [scrollHeight]="'45vh'"
            [value]="filter.values"
            [filter]="true"
            selectionMode="checkbox"
            (selectionChange)="outlined = false"
            [(selection)]="values[filter.name]"
          >
            <ng-template let-node pTemplate="default">
              <div>
                <span>{{ node.label | translate }}</span>
              </div>
            </ng-template>
          </p-tree>
        } @else if (filter.type == "list") {
          @if(!filter.search) {
            <div class="align-items-center mb-2 pl-3 mt-5" [style]="{ width: '18rem' }">
              <p-iconField iconPosition="left" class="w-full">
                <p-inputIcon styleClass="pi pi-search" />
                <input
                  type="text"
                  pInputText
                  (keydown.enter)="onFilter($event)"
                  placeholder="{{ 'settings.searchShop' | translate }}"
                  class=""
                />
              </p-iconField>
            </div>
          }@else {
            <div class="mt-4">

            </div>
          }
      
          <p-listbox
            [options]="filter.values"
            [(ngModel)]="values[filter.name]"
            [optionLabel]="filter.display"
            [style]="{ width: '18rem' }"
            [multiple]="filter.selectionMode=== 'single' ? false : true"
            [metaKeySelection]="false"
            [filter]="filter.search"
            [listStyle]="{ 'max-height': '220px' }"
            [showToggleAll]="false"
            [filterPlaceHolder]="'settings.searchShop' | translate "
          />
          @if(!filter.search) {
            <div class="pagination-controls align-items-center mb-5" [style]="{ width: '20rem' }">
              <div class="page-buttons">
                <p-button 
                  icon="pi pi-chevron-left" 
                  (onClick)="previousPage()" 
                  [disabled]="currentPage === 0"></p-button>
                <p-button 
                  icon="pi pi-chevron-right" 
                  (onClick)="nextPage()" 
                  [disabled]="!hasNext"></p-button>
              </div>
            </div>
          }
        }
      </div>
    </div>
  }
</div>

<div class="footer-idfx">
  <p-button
    type="button"
    [label]="'buttons.validate' | translate"
    icon="pi pi-check-square"
    [outlined]="outlined"
    (click)="closeModal()"
  />
</div>
